class SearchForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const form = this.querySelector('form');
    const searchInput = document.getElementById('search');
    const tabSections = document.querySelectorAll('[data-items][data-tab]');
    const countBadges = document.querySelectorAll('.page-search__header-btn [data-count]');

    form.addEventListener('submit', e => e.preventDefault())

    function getSelectedFilters(tab) {
      const filters = {};
      const inputs = document.querySelectorAll(`[data-tab="${tab.dataset.tab}"] input:checked`);
      inputs.forEach(input => {
        const name = input.name;
        if (!filters[name]) filters[name] = [];
        filters[name].push(input.value);
      });
      return filters;
    }

    function filterItems() {
      const query = searchInput.value.trim().toLowerCase();

      tabSections.forEach((tab, tabIndex) => {
        const items = tab.querySelectorAll('[data-item]');
        const filters = getSelectedFilters(tab);
        let visibleCount = 0;

        items.forEach(item => {
          const text = item.textContent.trim().toLowerCase();
          const matchesSearch = text.includes(query);
          let matchesFilters = true;

          for (const [name, values] of Object.entries(filters)) {
            const attr = `data-${name}`;
            const dataVal = item.getAttribute(attr);
            if (!dataVal) {
              matchesFilters = false;
              break;
            }
            try {
              const dataArray = JSON.parse(dataVal.replace(/'/g, '"'));
              const hasMatch = dataArray.some(v => values.includes(String(v)));
              if (!hasMatch) {
                matchesFilters = false;
                break;
              }
            } catch (e) {
              matchesFilters = false;
              break;
            }
          }

          const shouldShow = matchesSearch && matchesFilters;
          item.style.display = shouldShow ? '' : 'none';
          if (shouldShow) visibleCount++;
        });

        // Update button count
        const countEl = countBadges[tabIndex];
        if (countEl) countEl.textContent = visibleCount;

        // Update tab content data-count
        tab.setAttribute('data-count', visibleCount);
      });
    }

    // Search input listener
    searchInput.addEventListener('input', filterItems);

    // Filter input listener
    document.querySelectorAll('.page-search__filter input').forEach(input => {
      input.addEventListener('change', filterItems);
    });

    // Reset buttons per tab
    document.querySelectorAll('.page-search__filter-reset[data-reset]').forEach(resetBtn => {
      resetBtn.addEventListener('click', () => {
        const tabKey = resetBtn.closest('[data-tab]').dataset.tab;
        document.querySelectorAll(`[data-tab="${tabKey}"] input`).forEach(input => {
          input.checked = false;
        });
        filterItems();
      });
    });

    // Initial run
    filterItems();
  }

  handleSubmit(event) {
  }
}

customElements.define('search-form', SearchForm);
